export enum loggedValues {
    SHEETS = 'sheets',
    LOGGED = 'logged',
    NOLOGGED = 'nologged'
};

export enum permissionsValues {
    MANAGER = 'manager',
};
